import { Gift, ArrowRight } from "lucide-react";

// House promo for the referral program — sits on the landing page under the
// sponsored ad spot. CTA opens signup (where a referred visitor's code is
// already auto-filled if they came from a ?ref= link).
export default function ReferralPromo({ variant = "classic" }) {
    const shape = variant === "operations" ? "rounded-xl" : variant === "editorial" ? "rounded-[1.5rem]" : "rounded-2xl";
    return (
        <div data-testid="referral-promo" className={`glass mt-4 flex flex-col items-center gap-4 border border-amber-500/25 p-4 sm:flex-row sm:p-5 ${shape}`}>
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl border border-amber-500/40 bg-amber-500/10">
                <Gift className="h-5 w-5 text-amber-400" />
            </span>
            <div className="min-w-0 flex-1 text-center sm:text-left">
                <span className="font-mono text-[9px] uppercase tracking-[0.22em] text-amber-500/80">Refer & earn</span>
                <p data-testid="referral-promo-title" className={`mt-0.5 font-display text-base sm:text-lg font-extrabold tracking-tight ${variant === "editorial" ? "italic" : "uppercase"}`}>
                    Give FORCE, get a <span className="text-amber-400">free month</span>
                </p>
                <p className="mt-0.5 text-xs text-zinc-400">Every 5 friends who join and go paid adds a free month to your account. Your link, your rewards.</p>
            </div>
            <button
                data-testid="referral-promo-cta"
                onClick={() => window.dispatchEvent(new CustomEvent("force:start-signup"))}
                className={`group flex shrink-0 items-center gap-1.5 self-center border border-amber-500/50 bg-amber-500/10 px-4 py-2 text-xs font-bold text-amber-300 transition-colors hover:bg-amber-500/20 ${variant === "operations" ? "rounded-lg font-mono uppercase tracking-wide" : "rounded-xl"}`}
            >
                Get your link <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
            </button>
        </div>
    );
}
